/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B000010 ログイン
 */

import { Box } from "@mui/material";
import {
  B000010Auth,
  B000010Login,
  B000010LoginRequest,
  B000011Valid,
  B000020Find,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SFrame,
  SLabel,
  SNormalButton,
  SText,
  STextField,
} from "components";
import { SBar } from "components/parts";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  authState,
  focusState,
  getAuth,
  getMenus,
  menusState,
  navigateTypeState,
  useFocus,
} from "states";

type Props = Partial<{}>;

type Fields = {
  shainCd: string;
  password: string;
};

const defaultFields: Fields = {
  shainCd: "",
  password: "",
};

const focusId = "B000010";

export const B000010 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  const { focus, register } = useRecoilValue(focusState(focusId));
  const setAuth = useSetRecoilState(authState);
  const setMenus = useSetRecoilState(menusState);
  const navigate = useNavigate();
  const setMsg = useSetRecoilState(msgState);
  const setMenuNavigate = useSetRecoilState(navigateTypeState);

  useEffect(() => {
    setMenuNavigate("menu");
    focus(1);
  }, []);

  const handleClick = () => {
    const fields = methods.getValues();
    const param: B000010LoginRequest = {
      shainCd: fields.shainCd,
      password: fields.password,
    };
    B000010Login(param)
      .then(() => {
        B000010Auth()
          .then((value) => {
            setAuth(getAuth(value.data));
            const kengenId = value.data.kengenId;
            B000011Valid()
              .then(() => {
                // 権限定義一覧を取得する。
                B000020Find({ kengenId: kengenId })
                  .then((value) => {
                    setMenus(getMenus(value.data));
                    navigate("/");
                  })
                  .catch(() => {
                    // 取得できない場合、ログイン画面へ遷移する。
                    navigate("/b000010");
                  });
              })
              .catch(() => {
                // 端末認証が未実施の場合、端末認証画面へ遷移する。
                navigate("/b000011");
              });
          })
          .catch((reason) => {
            catchRestError(reason, navigate, setMsg);
          });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  return (
    <FormProvider {...methods}>
      <SBar />
      <SFrame title="ログイン" height="fit-content" margin={10}>
        <Box display="flex" justifyContent="center">
          <SFrame
            display="grid"
            gridTemplateColumns="7rem 7rem"
            rowGap="5px"
            margin={8}
          >
            <SLabel required>ログインID</SLabel>
            <STextField
              label="ログインID"
              name="shainCd"
              {...register(1)}
              size={7}
              required
            />
            <SLabel required>パスワード</SLabel>
            <STextField
              label="パスワード"
              name="password"
              {...register(2)}
              required
              password
            />
            <Box display="flex" justifyContent="center" gridColumn="span 2">
              <SNormalButton
                label="ログイン"
                {...register(3)}
                onClick={handleClick}
              />
            </Box>
          </SFrame>
        </Box>
        <SText>当サイトはGoogle Chromeの最新版にてご利用ください。</SText>
      </SFrame>
    </FormProvider>
  );
};
